<!--
 * @FilePath: /daren-html-source/src/views/Account/components/tab2.vue
 * @Description: 收款人管理
-->
<template>
  <div class="tab2">
    <fm-button
      icon="icon-add"
      @click="addpayeeBtn"
      type="primary"
      size="medium"
      >{{ $t('IncomeReflect.tabTwo.NewPayee') }}</fm-button
    >
    <div>
      <div class="tableHeader">
        <div
          v-for="(item, index) in tableHeader"
          :key="index"
          :class="`table${index}`"
        >
          <span v-if="index != 4 || lang != 'en'">{{ item }}</span>
          <el-tooltip v-if="index == 4 && lang == 'en'" class="item" effect="dark" :content="item" placement="bottom">
            <span>{{ item }}</span>
          </el-tooltip>
        </div>
      </div>
      <div class="tableContent" v-loading="loadingFlag">
        <div class="empty" v-if="total == 0">
          <img class="emptyImg" :src="$utils.getPng('icon_new_empty')" alt="" />
          <div class="emptyText">{{ $t('IncomeReflect.tabTwo.NoRecord') }}</div>
        </div>
        <div v-else>
          <div class="item" v-for="item in list" :key="item">
            <div class="table0">{{ item.income_account }}</div>
            <div class="table1">{{ item.payee_type_label }}</div>
            <!-- <div class="table2">{{ $utils.hideIdcard(item.account) }}</div> -->
            <div class="table2">{{ item.account_format }}</div>
            <div class="table3">¥ {{ item.yearly_money_total }}</div>
            <div class="table4">{{ item.monthly_times_used }}次</div>
            <div class="table5">
              <div class="editbox pointer" @click="showAdd(item)">
                {{ $t('IncomeReflect.tabTwo.Editor') }}
              </div>
              <div class="deleteBox pointer" @click="deletePayee(item)">
                {{ $t('IncomeReflect.tabTwo.Delete') }}
              </div>
            </div>
          </div>
        </div>
        <ChangePhoneDiaVue
          ref="ChangePhoneDia"
          :userInfo="userInfo"
          :showChangePhoneFlag="showChangePhoneFlag"
          @handleClose="showChangePhoneFlag = false"
        ></ChangePhoneDiaVue>
        <AddPayee 
          ref="AddPayee" 
          :editId="editId" 
          :isEdit="isEdit"
          :isShow="showAddpayFlag" />
        <DeletePayee
          :isShow="showDeletepayFlag"
          @handleClose="showDeletepayFlag = false"
          @confirm="deletePayeeConfirm"
        />
        <div class="pagation">
          <PaginationCom
            ref="paginationCom"
            :total="total"
            @changepage="changepage"
          ></PaginationCom>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationCom from '@/components/pagination/index.vue'
import AddPayee from '@/components/AddPayee/index.vue'
import DeletePayee from '@/components/DeleteDia/index.vue'
import ChangePhoneDiaVue from '@/components/ChangePhoneDIa/index.vue'
import {
  getPayeeListAPI,
  dletePayeeAPI,
  userInfoAPI,
} from '@/utils/apiList/user'

export default {
  components: {
    PaginationCom,
    AddPayee,
    DeletePayee,
    ChangePhoneDiaVue,
  },
  data() {
    return {
      tableHeader: [
        this.$t('IncomeReflect.tabZero.Payee'),
        this.$t('IncomeReflect.tabTwo.PaymentMethod'),
        this.$t('IncomeReflect.tabTwo.PaymentAccount'),
        this.$t('IncomeReflect.tabTwo.AnnualWithdrawalLimit'),
        this.$t('IncomeReflect.tabTwo.MonthlyWithdrawalCount'),
        this.$t('IncomeReflect.tabTwo.Controls'),
      ],
      list: [],
      total: null,
      page: 1,
      showAddpayFlag: false,
      showDeletepayFlag: false,
      deleteId: '',
      loadingFlag: false,
      userInfo: {},
      showChangePhoneFlag: false,
      lang: '',
      editId:0,
      isEdit:0,
    }
  },
  created() {
    this.getUser()
    this.getPayeeList()
  },
  mounted() {
    this.lang = localStorage.getItem('lang')??'zh'
  },
  methods: {
    getUser() {
      userInfoAPI()
        .then(res => {
          if (res.status == 1) {
            this.userInfo = res.data
            this.$store.commit('setAttr', {
              name: 'userInfo',
              val: res.data,
            })
            localStorage.setItem('isDaren', res.data.is_rate_flow)
          }
        })
        .catch(err => {})
    },
    changepage(page) {
      this.page = page
      this.getPayeeList()
    },
    getPayeeList() {
      this.loadingFlag = true
      getPayeeListAPI({ page: this.page, limit: 20 }).then(res => {
        this.loadingFlag = false
        if (res.status == 1) {
          this.list = res.data.accountList.list
          this.total = parseInt(res.data.accountList.total)
        }
      })
    },
    showAdd(item) {
      this.editId = item.id
      this.isEdit = 1
      this.showAddpayFlag = true
      this.$refs.AddPayee.resetTime()
      this.$refs.AddPayee.form.region = item.region
      this.$refs.AddPayee.form.last_name = item.last_name
      this.$refs.AddPayee.form.first_name = item.first_name
      this.$refs.AddPayee.form.account = item.account
      this.$refs.AddPayee.form.phone = item.phone
      this.$refs.AddPayee.form.pucode = item.pucode
      this.$refs.AddPayee.form.payee_type = Number(item.payee_type)
      this.$refs.AddPayee.form.aliacc = item.aliacc
      this.$refs.AddPayee.form.bank_account_number = item.bank_account_number
      this.$refs.AddPayee.form.detailed_address = item.detailed_address
      this.$refs.AddPayee.form.usdt_trc20_address = item.usdt_trc20_address
      this.$refs.AddPayee.form.bank_name = item.bank_name
      this.$refs.AddPayee.form.bank_code = item.bank_code
      this.$refs.AddPayee.form.branch_code = item.branch_code
      this.$refs.AddPayee.form.swift_code = item.swift_code
      this.$refs.AddPayee.form.postal_code = item.postal_code
      this.$refs.AddPayee.form.city = item.city
    },
    addpayeeBtn() {
      if (
        this.userInfo.is_bind_phone == 0 &&
        this.userInfo.is_income_account == 0
      ) {
        this.$refs.ChangePhoneDia.step = 2
        this.$refs.ChangePhoneDia.topTit = '绑定手机号'
        this.showChangePhoneFlag = true
      } else {
        this.editId = 0
        this.isEdit = 0
        this.showAddpayFlag = true
      }
    },
    deletePayee(item) {
      this.deleteId = item.id
      this.showDeletepayFlag = true
    },
    deletePayeeConfirm() {
      dletePayeeAPI({ id: this.deleteId }).then(res => {
        if (res.status == 1) {
          this.$toast(res.msg, 1)
          this.deleteId = ''
          this.showDeletepayFlag = false
          this.changepage(1)
          this.$refs.paginationCom.setPage(1)
          this.getUser()
        } else {
          this.$toast(res.msg, 2)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tab2 {
  margin-top: 32px;
  .table0 {
    width: 140px;
    @include multiline(1);
    margin-right: 12px;
  }
  .table1 {
    // width: 100px;
    width: 140px;
    @include multiline(1);
    margin-right: 12px;
  }

  .table2 {
    width: 200px;
    @include multiline(1);
    margin-right: 32px;
  }
  .table3 {
    width: 120px;
    @include multiline(1);
    margin-right: 24px;
  }
  .table4 {
    width: 160px;
    @include multiline(1);
    margin-right: 28px;
  }
  .table5 {
    width: 132px;
    margin-left: auto;
    margin-right: 0;
    display: flex;
    justify-content: center;
  }
  .tableHeader {
    width: 100%;
    height: 52px;
    background: #f9f9f9;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
    color: #8a8b92;
    display: flex;
    align-items: center;
    padding: 0 24px;
    margin-top: 20px;
  }
  .tableContent {
    display: flex;
    flex-direction: column;
    min-height: 380px;
    .empty {
      display: flex;
      flex-direction: column;
      width: 100%;
      align-items: center;
      margin-top: 104px;
      .emptyImg {
        width: 100px;
        height: 100px;
      }
      .emptyText {
        margin-top: 8px;
        font-size: 16px;
        color: #8a8b92;
      }
    }
    .item {
      font-size: 14px;
      color: #2c2c2c;
      display: flex;
      align-items: center;
      padding: 0 24px;
      height: 56px;
      box-shadow: inset 0px -1px 0px 0px #f6f6f6;
    }
    .pagation {
      margin-left: auto;
      margin-right: 0;
      margin-top: 94px;
    }
    .table5 {
      display: flex;
      height: 22px;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      .editbox {
        color: #2c2c2c;
      }
      .deleteBox {
        color: #f53f3f;
        margin-left: 14px;
      }
    }
  }
}
</style>
